// import React from 'react'
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
// import { Doughnut } from 'react-chartjs-2'
// import { Request } from '../hooks/Request'

// ChartJS.register(ArcElement, Tooltip, Legend)

// export function GraficChart({ values, year }) {
//   const { data: companyId } = Request({
//     urlApi: values.id ? `/clientStats/companies/${values?.id}?` : null,
//   })
//   const data = {
//     labels: ['Proceso', 'Concluidos'],
//     datasets: [
//       {
//         label: '# of Votes',
//         data: [
//           // companyId?.totalStarted,
//           companyId?.totalInProgres,
//           companyId?.totalFinished,
//         ],
//         // data: [30, 40, 30],
//         backgroundColor: ['rgba(5, 110, 252 )', 'rgba(2, 232, 255,0.5 )'],
//         // borderColor: ['rgba(5, 76, 252 )', 'rgba(2, 209, 255 )'],
//         borderWidth: 3,
//         cutout: 50,
//       },
//     ],
//   }
//   return <Doughnut data={data} />
// }
import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { Request } from '../hooks/Request'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export function GraficChart({ values }) {
  const { data: gestionData } = Request({
    urlApi: values.id ? `/clientStats/companies/${values.id}?` : null,
  })

  const data = {
    labels: gestionData?.map(item => item.gestion) ?? [],
    datasets: [
      {
        label: 'Cantidad',
        data: gestionData?.map(item => item.cantidad) ?? [],
        backgroundColor: '#618BCC',
        borderColor: '#618BCC',
        borderWidth: 1,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'bottom', display: false },
      title: {
        display: false,
        text: 'Procedimientos por Gestión',
      },
    },
  }

  return <Bar data={data} options={options} />
}
